import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { UntypedFormControl } from '@angular/forms';
import { AccountingApiService } from '@app/modules/businesses/services/accounting.api';
import { AccountingService } from '@app/modules/my-business/services/accounting.service';
import { BehaviorSubject, catchError, EMPTY, filter, map, take } from 'rxjs';

@Component({
  selector: 'sbnb-accounting-form',
  templateUrl: './accounting-form.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountingFormComponent implements OnInit {
  @Input() editing = false;

  // Dependencies
  private readonly accountingService = inject(AccountingService);
  private readonly accountingApiService = inject(AccountingApiService);
  private readonly fb = inject(FormBuilder);

  public form: UntypedFormGroup = this.fb.group({
    currency: new UntypedFormControl(''),
  });
  public formInitialized$ = new BehaviorSubject<boolean>(false);
  public saving$ = new BehaviorSubject<boolean>(false);

  public ngOnInit() {
    this.accountingService.formState$
      .pipe(
        filter((state) => state.data !== null),
        map((state) => state.data),
        take(1)
      )
      .subscribe((data) => {
        // Set up properties form group
        this.form.addControl(
          'properties',
          this.fb.group(
            Object.entries(data.properties.fieldMap).reduce((acc, [id, field]) => {
              acc[id] = new UntypedFormControl((field as any).value);
              return acc;
            }, {})
          )
        );
        this.formInitialized$.next(true);
      });
  }

  public save() {
    this.saving$.next(true);

    this.accountingApiService
      .saveAccountingConnectionConfig(this.accountingService.connectionId$.value, this.dataForSubmission)
      .pipe(
        catchError((error) => {
          this.saving$.next(false);
          return EMPTY;
        })
      )
      .subscribe(() => {
        this.saving$.next(false);
      });
  }

  public get dataForSubmission() {
    const data = {
      currency: this.form.get('currency').value,
      properties: Object.entries(this.form.get('properties').value).map(([propertyId, fieldValue]: [string, any]) => ({
        id: Number(propertyId),
        tracking_category: Number(fieldValue),
        use_default: !!fieldValue,
      })),
      accounts: [],
      owners: [],
    };
    return data;
  }
}
